'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.types = exports.templates = undefined;

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _isUrl = require('./isUrl');

var _isUrl2 = _interopRequireDefault(_isUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OABfirstPhaseTemplate = [{
	title: 'Direito Administrativo',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Ambiental',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Civil',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Constitucional',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito do Consumidor',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Empresarial',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direitos Humanos',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Internacional',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Penal',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Processual Civil',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Processual Penal',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Processual do Trabalho',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito do Trabalho',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Tributário',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Estatuto da Criança e do Adolescente',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Ética',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Filosofia do Direito',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}];

var OABsecondPhaseTemplate = [{
	title: 'Direito Administrativo',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Civil',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Constitucional',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Empresarial',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Penal',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito do Trabalho',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}, {
	title: 'Direito Tributário',
	key: _uuid2.default.v4(),
	children: [],
	type: 'list',
	isPremium: false,
	value: '',
	params: {}
}];

var templates = exports.templates = {
	OABfirstPhaseTemplate: OABfirstPhaseTemplate,
	OABsecondPhaseTemplate: OABsecondPhaseTemplate,
	emptyTemplate: []
};

var types = exports.types = [{ name: 'PDF', value: 'pdf', validation: pdfValidation }, { name: 'Link', value: 'url', validation: linkValidation },
// { name: 'Função JavaScript', value: 'function', validation: genericValidation },
// { name: 'Tela do Aplicativo (Somente Mobile)', value: 'widget', validation: genericValidation },
{ name: 'Lista', value: 'list', validation: listValidation },
// { name: 'Webview', value: 'webview', validation: webViewValidation },
{ name: 'Texto', value: 'text', validation: textValidation }, { name: 'SubLista', value: 'subList', validation: listValidation }, { name: 'Imagem', value: 'image', validation: imageValidation }, { name: 'Vídeo', value: 'video', validation: videoValidation }, { name: 'Separador', value: 'separator', validation: function validation() {
		return true;
	} }, { name: 'Item de Lista', value: 'listItem', validation: listItemValidation }];

function genericValidation(row) {
	if (typeof row.type !== 'string' || row.type.length === 0) {
		return 'type';
	}

	if (typeof row.title !== 'string' || row.title.length === 0) {
		return 'title';
	}

	if (typeof row.value !== 'string' || row.value.length === 0) {
		return 'value';
	}

	if (typeof row.isPremium !== 'boolean') {
		return 'isPremium';
	}

	return true;
}

function listValidation(row) {
	if (typeof row.type !== 'string' || row.type.length === 0) {
		return 'type';
	}

	if (typeof row.title !== 'string' || row.title.length === 0) {
		return 'title';
	}

	if (typeof row.isPremium !== 'boolean') {
		return 'isPremium';
	}

	return true;
}

function textValidation(row) {
	if ((typeof row.value !== 'string' || row.value.length === 0) && (typeof row.title !== 'string' || row.title.length === 0)) {
		return 'value';
	}

	return true;
}

function listItemValidation(row) {
	if (typeof row.value !== 'string' || row.value.length === 0) {
		return 'value';
	}

	return true;
}

function pdfValidation(row) {
	var generic = genericValidation(row);

	if (generic !== true) {
		return generic;
	}

	if (!(0, _isUrl2.default)(row.value) || !row.value.toLowerCase().includes('.pdf')) {
		return 'value';
	}

	return true;
}

function imageValidation(row) {
	var generic = genericValidation(row);

	if (generic !== true) {
		return generic;
	}

	var value = row.value;
	var thumbnail = row.thumbnail;

	var isImage = ['.jpg', '.gif', '.png', '.jpeg'].some(function (format) {
		return value.toLowerCase().includes(format);
	});
	var thumbnailIsImage = ['.jpg', '.gif', '.png', '.jpeg'].some(function (format) {
		return thumbnail.toLowerCase().includes(format);
	});

	if (!(0, _isUrl2.default)(value) || !isImage) {
		return 'value';
	}

	if (!(0, _isUrl2.default)(thumbnail) || !thumbnailIsImage) {
		return 'thumbnail';
	}

	return true;
}

function webViewValidation(row) {
	var generic = genericValidation(row);

	if (generic !== true) {
		return generic;
	}

	if (!(0, _isUrl2.default)(row.value) || !row.value.toLowerCase().includes('.html')) {
		return 'value';
	}

	return true;
}

function linkValidation(row) {
	var generic = genericValidation(row);

	if (generic !== true) {
		return generic;
	}

	if (!(0, _isUrl2.default)(row.value)) {
		return 'value';
	}

	if (typeof row.isExternal !== 'boolean' && typeof row.isExternal !== 'undefined') {
		return 'isExternal';
	}

	return true;
}

function videoValidation(row) {
	var generic = genericValidation(row);

	if (generic !== true) {
		return generic;
	}

	if (!(0, _isUrl2.default)(row.value)) {
		return 'value';
	}

	if (typeof row.thumbnail !== 'undefined' && typeof row.thumbnail !== 'string' && !(0, _isUrl2.default)(row.thumbnail)) {
		return 'thumbnail';
	}

	return true;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbGliL2dlbmVyaWNNYXRlcmlhbERlZmF1bHRzLmpzIl0sIm5hbWVzIjpbIk9BQmZpcnN0UGhhc2VUZW1wbGF0ZSIsInRpdGxlIiwia2V5IiwidXVpZCIsInY0IiwiY2hpbGRyZW4iLCJ0eXBlIiwiaXNQcmVtaXVtIiwidmFsdWUiLCJwYXJhbXMiLCJPQUJzZWNvbmRQaGFzZVRlbXBsYXRlIiwidGVtcGxhdGVzIiwiZW1wdHlUZW1wbGF0ZSIsInR5cGVzIiwibmFtZSIsInZhbGlkYXRpb24iLCJwZGZWYWxpZGF0aW9uIiwibGlua1ZhbGlkYXRpb24iLCJsaXN0VmFsaWRhdGlvbiIsInRleHRWYWxpZGF0aW9uIiwiaW1hZ2VWYWxpZGF0aW9uIiwidmlkZW9WYWxpZGF0aW9uIiwibGlzdEl0ZW1WYWxpZGF0aW9uIiwiZ2VuZXJpY1ZhbGlkYXRpb24iLCJyb3ciLCJsZW5ndGgiLCJnZW5lcmljIiwidG9Mb3dlckNhc2UiLCJpbmNsdWRlcyIsInRodW1ibmFpbCIsImlzSW1hZ2UiLCJzb21lIiwiZm9ybWF0IiwidGh1bWJuYWlsSXNJbWFnZSIsIndlYlZpZXdWYWxpZGF0aW9uIiwiaXNFeHRlcm5hbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLHdCQUF3QixDQUFDO0FBQzlCQyxRQUFPLHdCQUR1QjtBQUU5QkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZ5QjtBQUc5QkMsV0FBVSxFQUhvQjtBQUk5QkMsT0FBTSxNQUp3QjtBQUs5QkMsWUFBVyxLQUxtQjtBQU05QkMsUUFBTyxFQU51QjtBQU85QkMsU0FBUTtBQVBzQixDQUFELEVBUTNCO0FBQ0ZSLFFBQU8sbUJBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0FSMkIsRUFnQjNCO0FBQ0ZSLFFBQU8sZUFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQWhCMkIsRUF3QjNCO0FBQ0ZSLFFBQU8sd0JBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0F4QjJCLEVBZ0MzQjtBQUNGUixRQUFPLHVCQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBaEMyQixFQXdDM0I7QUFDRlIsUUFBTyxxQkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQXhDMkIsRUFnRDNCO0FBQ0ZSLFFBQU8sa0JBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0FoRDJCLEVBd0QzQjtBQUNGUixRQUFPLHVCQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBeEQyQixFQWdFM0I7QUFDRlIsUUFBTyxlQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBaEUyQixFQXdFM0I7QUFDRlIsUUFBTywwQkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQXhFMkIsRUFnRjNCO0FBQ0ZSLFFBQU8sMEJBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0FoRjJCLEVBd0YzQjtBQUNGUixRQUFPLGdDQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBeEYyQixFQWdHM0I7QUFDRlIsUUFBTyxxQkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQWhHMkIsRUF3RzNCO0FBQ0ZSLFFBQU8sb0JBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0F4RzJCLEVBZ0gzQjtBQUNGUixRQUFPLHNDQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBaEgyQixFQXdIM0I7QUFDRlIsUUFBTyxPQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBeEgyQixFQWdJM0I7QUFDRlIsUUFBTyxzQkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQWhJMkIsQ0FBOUI7O0FBMElBLElBQU1DLHlCQUF5QixDQUFDO0FBQy9CVCxRQUFPLHdCQUR3QjtBQUUvQkMsTUFBS0MsZUFBS0MsRUFBTCxFQUYwQjtBQUcvQkMsV0FBVSxFQUhxQjtBQUkvQkMsT0FBTSxNQUp5QjtBQUsvQkMsWUFBVyxLQUxvQjtBQU0vQkMsUUFBTyxFQU53QjtBQU8vQkMsU0FBUTtBQVB1QixDQUFELEVBUTVCO0FBQ0ZSLFFBQU8sZUFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQVI0QixFQWdCNUI7QUFDRlIsUUFBTyx3QkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQWhCNEIsRUF3QjVCO0FBQ0ZSLFFBQU8scUJBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0F4QjRCLEVBZ0M1QjtBQUNGUixRQUFPLGVBREw7QUFFRkMsTUFBS0MsZUFBS0MsRUFBTCxFQUZIO0FBR0ZDLFdBQVUsRUFIUjtBQUlGQyxPQUFNLE1BSko7QUFLRkMsWUFBVyxLQUxUO0FBTUZDLFFBQU8sRUFOTDtBQU9GQyxTQUFRO0FBUE4sQ0FoQzRCLEVBd0M1QjtBQUNGUixRQUFPLHFCQURMO0FBRUZDLE1BQUtDLGVBQUtDLEVBQUwsRUFGSDtBQUdGQyxXQUFVLEVBSFI7QUFJRkMsT0FBTSxNQUpKO0FBS0ZDLFlBQVcsS0FMVDtBQU1GQyxRQUFPLEVBTkw7QUFPRkMsU0FBUTtBQVBOLENBeEM0QixFQWdENUI7QUFDRlIsUUFBTyxvQkFETDtBQUVGQyxNQUFLQyxlQUFLQyxFQUFMLEVBRkg7QUFHRkMsV0FBVSxFQUhSO0FBSUZDLE9BQU0sTUFKSjtBQUtGQyxZQUFXLEtBTFQ7QUFNRkMsUUFBTyxFQU5MO0FBT0ZDLFNBQVE7QUFQTixDQWhENEIsQ0FBL0I7O0FBMERPLElBQU1FLGdDQUFZO0FBQ3hCWCw2Q0FEd0I7QUFFeEJVLCtDQUZ3QjtBQUd4QkUsZ0JBQWU7QUFIUyxDQUFsQjs7QUFNQSxJQUFNQyx3QkFBUSxDQUNwQixFQUFFQyxNQUFNLEtBQVIsRUFBZU4sT0FBTyxLQUF0QixFQUE2Qk8sWUFBWUMsYUFBekMsRUFEb0IsRUFFcEIsRUFBRUYsTUFBTSxNQUFSLEVBQWdCTixPQUFPLEtBQXZCLEVBQThCTyxZQUFZRSxjQUExQyxFQUZvQjtBQUdwQjtBQUNBO0FBQ0EsRUFBRUgsTUFBTSxPQUFSLEVBQWlCTixPQUFPLE1BQXhCLEVBQWdDTyxZQUFZRyxjQUE1QyxFQUxvQjtBQU1wQjtBQUNBLEVBQUVKLE1BQU0sT0FBUixFQUFpQk4sT0FBTyxNQUF4QixFQUFnQ08sWUFBWUksY0FBNUMsRUFQb0IsRUFRcEIsRUFBRUwsTUFBTSxVQUFSLEVBQW9CTixPQUFPLFNBQTNCLEVBQXNDTyxZQUFZRyxjQUFsRCxFQVJvQixFQVNwQixFQUFFSixNQUFNLFFBQVIsRUFBa0JOLE9BQU8sT0FBekIsRUFBa0NPLFlBQVlLLGVBQTlDLEVBVG9CLEVBVXBCLEVBQUVOLE1BQU0sT0FBUixFQUFpQk4sT0FBTyxPQUF4QixFQUFpQ08sWUFBWU0sZUFBN0MsRUFWb0IsRUFXcEIsRUFBRVAsTUFBTSxXQUFSLEVBQXFCTixPQUFPLFdBQTVCLEVBQXlDTyxZQUFZO0FBQUEsU0FBTSxJQUFOO0FBQUEsRUFBckQsRUFYb0IsRUFZcEIsRUFBRUQsTUFBTSxlQUFSLEVBQXlCTixPQUFPLFVBQWhDLEVBQTRDTyxZQUFZTyxrQkFBeEQsRUFab0IsQ0FBZDs7QUFlUCxTQUFTQyxpQkFBVCxDQUEyQkMsR0FBM0IsRUFBZ0M7QUFDL0IsS0FBSSxPQUFPQSxJQUFJbEIsSUFBWCxLQUFvQixRQUFwQixJQUFnQ2tCLElBQUlsQixJQUFKLENBQVNtQixNQUFULEtBQW9CLENBQXhELEVBQTJEO0FBQzFELFNBQU8sTUFBUDtBQUNBOztBQUVELEtBQUksT0FBT0QsSUFBSXZCLEtBQVgsS0FBcUIsUUFBckIsSUFBaUN1QixJQUFJdkIsS0FBSixDQUFVd0IsTUFBVixLQUFxQixDQUExRCxFQUE2RDtBQUM1RCxTQUFPLE9BQVA7QUFDQTs7QUFFRCxLQUFJLE9BQU9ELElBQUloQixLQUFYLEtBQXFCLFFBQXJCLElBQWlDZ0IsSUFBSWhCLEtBQUosQ0FBVWlCLE1BQVYsS0FBcUIsQ0FBMUQsRUFBNkQ7QUFDNUQsU0FBTyxPQUFQO0FBQ0E7O0FBRUQsS0FBSSxPQUFPRCxJQUFJakIsU0FBWCxLQUF5QixTQUE3QixFQUF3QztBQUN2QyxTQUFPLFdBQVA7QUFDQTs7QUFFRCxRQUFPLElBQVA7QUFDQTs7QUFFRCxTQUFTVyxjQUFULENBQXdCTSxHQUF4QixFQUE2QjtBQUM1QixLQUFJLE9BQU9BLElBQUlsQixJQUFYLEtBQW9CLFFBQXBCLElBQWdDa0IsSUFBSWxCLElBQUosQ0FBU21CLE1BQVQsS0FBb0IsQ0FBeEQsRUFBMkQ7QUFDMUQsU0FBTyxNQUFQO0FBQ0E7O0FBRUQsS0FBSSxPQUFPRCxJQUFJdkIsS0FBWCxLQUFxQixRQUFyQixJQUFpQ3VCLElBQUl2QixLQUFKLENBQVV3QixNQUFWLEtBQXFCLENBQTFELEVBQTZEO0FBQzVELFNBQU8sT0FBUDtBQUNBOztBQUVELEtBQUksT0FBT0QsSUFBSWpCLFNBQVgsS0FBeUIsU0FBN0IsRUFBd0M7QUFDdkMsU0FBTyxXQUFQO0FBQ0E7O0FBRUQsUUFBTyxJQUFQO0FBQ0E7O0FBRUQsU0FBU1ksY0FBVCxDQUF3QkssR0FBeEIsRUFBNkI7QUFDNUIsS0FBSSxDQUFDLE9BQU9BLElBQUloQixLQUFYLEtBQXFCLFFBQXJCLElBQWlDZ0IsSUFBSWhCLEtBQUosQ0FBVWlCLE1BQVYsS0FBcUIsQ0FBdkQsTUFBOEQsT0FBT0QsSUFBSXZCLEtBQVgsS0FBcUIsUUFBckIsSUFBaUN1QixJQUFJdkIsS0FBSixDQUFVd0IsTUFBVixLQUFxQixDQUFwSCxDQUFKLEVBQTRIO0FBQzNILFNBQU8sT0FBUDtBQUNBOztBQUVELFFBQU8sSUFBUDtBQUNBOztBQUdELFNBQVNILGtCQUFULENBQTRCRSxHQUE1QixFQUFpQztBQUNoQyxLQUFJLE9BQU9BLElBQUloQixLQUFYLEtBQXFCLFFBQXJCLElBQWlDZ0IsSUFBSWhCLEtBQUosQ0FBVWlCLE1BQVYsS0FBcUIsQ0FBMUQsRUFBNkQ7QUFDNUQsU0FBTyxPQUFQO0FBQ0E7O0FBRUQsUUFBTyxJQUFQO0FBQ0E7O0FBRUQsU0FBU1QsYUFBVCxDQUF1QlEsR0FBdkIsRUFBNEI7QUFDM0IsS0FBTUUsVUFBVUgsa0JBQWtCQyxHQUFsQixDQUFoQjs7QUFFQSxLQUFJRSxZQUFZLElBQWhCLEVBQXNCO0FBQ3JCLFNBQU9BLE9BQVA7QUFDQTs7QUFFRCxLQUFJLENBQUMscUJBQU1GLElBQUloQixLQUFWLENBQUQsSUFBcUIsQ0FBQ2dCLElBQUloQixLQUFKLENBQVVtQixXQUFWLEdBQXdCQyxRQUF4QixDQUFpQyxNQUFqQyxDQUExQixFQUFvRTtBQUNuRSxTQUFPLE9BQVA7QUFDQTs7QUFFRCxRQUFPLElBQVA7QUFDQTs7QUFFRCxTQUFTUixlQUFULENBQXlCSSxHQUF6QixFQUE4QjtBQUM3QixLQUFNRSxVQUFVSCxrQkFBa0JDLEdBQWxCLENBQWhCOztBQUVBLEtBQUlFLFlBQVksSUFBaEIsRUFBc0I7QUFDckIsU0FBT0EsT0FBUDtBQUNBOztBQUVELEtBQU1sQixRQUFRZ0IsSUFBSWhCLEtBQWxCO0FBQ0EsS0FBTXFCLFlBQVlMLElBQUlLLFNBQXRCOztBQUVBLEtBQU1DLFVBQVUsQ0FBQyxNQUFELEVBQVMsTUFBVCxFQUFpQixNQUFqQixFQUF5QixPQUF6QixFQUFrQ0MsSUFBbEMsQ0FBdUMsVUFBQ0MsTUFBRDtBQUFBLFNBQVl4QixNQUFNbUIsV0FBTixHQUFvQkMsUUFBcEIsQ0FBNkJJLE1BQTdCLENBQVo7QUFBQSxFQUF2QyxDQUFoQjtBQUNBLEtBQU1DLG1CQUFtQixDQUFDLE1BQUQsRUFBUyxNQUFULEVBQWlCLE1BQWpCLEVBQXlCLE9BQXpCLEVBQWtDRixJQUFsQyxDQUF1QyxVQUFDQyxNQUFEO0FBQUEsU0FBWUgsVUFBVUYsV0FBVixHQUF3QkMsUUFBeEIsQ0FBaUNJLE1BQWpDLENBQVo7QUFBQSxFQUF2QyxDQUF6Qjs7QUFFQSxLQUFJLENBQUMscUJBQU14QixLQUFOLENBQUQsSUFBaUIsQ0FBQ3NCLE9BQXRCLEVBQStCO0FBQzlCLFNBQU8sT0FBUDtBQUNBOztBQUVELEtBQUksQ0FBQyxxQkFBTUQsU0FBTixDQUFELElBQXFCLENBQUNJLGdCQUExQixFQUE0QztBQUMzQyxTQUFPLFdBQVA7QUFDQTs7QUFFRCxRQUFPLElBQVA7QUFDQTs7QUFFRCxTQUFTQyxpQkFBVCxDQUEyQlYsR0FBM0IsRUFBZ0M7QUFDL0IsS0FBTUUsVUFBVUgsa0JBQWtCQyxHQUFsQixDQUFoQjs7QUFFQSxLQUFJRSxZQUFZLElBQWhCLEVBQXNCO0FBQ3JCLFNBQU9BLE9BQVA7QUFDQTs7QUFFRCxLQUFJLENBQUMscUJBQU1GLElBQUloQixLQUFWLENBQUQsSUFBcUIsQ0FBQ2dCLElBQUloQixLQUFKLENBQVVtQixXQUFWLEdBQXdCQyxRQUF4QixDQUFpQyxPQUFqQyxDQUExQixFQUFxRTtBQUNwRSxTQUFPLE9BQVA7QUFDQTs7QUFFRCxRQUFPLElBQVA7QUFDQTs7QUFHRCxTQUFTWCxjQUFULENBQXdCTyxHQUF4QixFQUE2QjtBQUM1QixLQUFNRSxVQUFVSCxrQkFBa0JDLEdBQWxCLENBQWhCOztBQUVBLEtBQUlFLFlBQVksSUFBaEIsRUFBc0I7QUFDckIsU0FBT0EsT0FBUDtBQUNBOztBQUVELEtBQUksQ0FBQyxxQkFBTUYsSUFBSWhCLEtBQVYsQ0FBTCxFQUF1QjtBQUN0QixTQUFPLE9BQVA7QUFDQTs7QUFFRCxLQUFJLE9BQU9nQixJQUFJVyxVQUFYLEtBQTBCLFNBQTFCLElBQXVDLE9BQU9YLElBQUlXLFVBQVgsS0FBMEIsV0FBckUsRUFBa0Y7QUFDakYsU0FBTyxZQUFQO0FBQ0E7O0FBRUQsUUFBTyxJQUFQO0FBQ0E7O0FBRUQsU0FBU2QsZUFBVCxDQUF5QkcsR0FBekIsRUFBOEI7QUFDN0IsS0FBTUUsVUFBVUgsa0JBQWtCQyxHQUFsQixDQUFoQjs7QUFFQSxLQUFJRSxZQUFZLElBQWhCLEVBQXNCO0FBQ3JCLFNBQU9BLE9BQVA7QUFDQTs7QUFFRCxLQUFJLENBQUMscUJBQU1GLElBQUloQixLQUFWLENBQUwsRUFBdUI7QUFDdEIsU0FBTyxPQUFQO0FBQ0E7O0FBRUQsS0FDQyxPQUFPZ0IsSUFBSUssU0FBWCxLQUF5QixXQUF6QixJQUNBLE9BQU9MLElBQUlLLFNBQVgsS0FBeUIsUUFEekIsSUFFQSxDQUFDLHFCQUFNTCxJQUFJSyxTQUFWLENBSEYsRUFJRTtBQUNELFNBQU8sV0FBUDtBQUNBOztBQUVELFFBQU8sSUFBUDtBQUNBIiwiZmlsZSI6ImdlbmVyaWNNYXRlcmlhbERlZmF1bHRzLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXVpZCBmcm9tICd1dWlkJztcbmltcG9ydCBpc1VybCBmcm9tICcuL2lzVXJsJztcblxuY29uc3QgT0FCZmlyc3RQaGFzZVRlbXBsYXRlID0gW3tcblx0dGl0bGU6ICdEaXJlaXRvIEFkbWluaXN0cmF0aXZvJyxcblx0a2V5OiB1dWlkLnY0KCksXG5cdGNoaWxkcmVuOiBbXSxcblx0dHlwZTogJ2xpc3QnLFxuXHRpc1ByZW1pdW06IGZhbHNlLFxuXHR2YWx1ZTogJycsXG5cdHBhcmFtczoge31cbn0sIHtcblx0dGl0bGU6ICdEaXJlaXRvIEFtYmllbnRhbCcsXG5cdGtleTogdXVpZC52NCgpLFxuXHRjaGlsZHJlbjogW10sXG5cdHR5cGU6ICdsaXN0Jyxcblx0aXNQcmVtaXVtOiBmYWxzZSxcblx0dmFsdWU6ICcnLFxuXHRwYXJhbXM6IHt9XG59LCB7XG5cdHRpdGxlOiAnRGlyZWl0byBDaXZpbCcsXG5cdGtleTogdXVpZC52NCgpLFxuXHRjaGlsZHJlbjogW10sXG5cdHR5cGU6ICdsaXN0Jyxcblx0aXNQcmVtaXVtOiBmYWxzZSxcblx0dmFsdWU6ICcnLFxuXHRwYXJhbXM6IHt9XG59LCB7XG5cdHRpdGxlOiAnRGlyZWl0byBDb25zdGl0dWNpb25hbCcsXG5cdGtleTogdXVpZC52NCgpLFxuXHRjaGlsZHJlbjogW10sXG5cdHR5cGU6ICdsaXN0Jyxcblx0aXNQcmVtaXVtOiBmYWxzZSxcblx0dmFsdWU6ICcnLFxuXHRwYXJhbXM6IHt9XG59LCB7XG5cdHRpdGxlOiAnRGlyZWl0byBkbyBDb25zdW1pZG9yJyxcblx0a2V5OiB1dWlkLnY0KCksXG5cdGNoaWxkcmVuOiBbXSxcblx0dHlwZTogJ2xpc3QnLFxuXHRpc1ByZW1pdW06IGZhbHNlLFxuXHR2YWx1ZTogJycsXG5cdHBhcmFtczoge31cbn0sIHtcblx0dGl0bGU6ICdEaXJlaXRvIEVtcHJlc2FyaWFsJyxcblx0a2V5OiB1dWlkLnY0KCksXG5cdGNoaWxkcmVuOiBbXSxcblx0dHlwZTogJ2xpc3QnLFxuXHRpc1ByZW1pdW06IGZhbHNlLFxuXHR2YWx1ZTogJycsXG5cdHBhcmFtczoge31cbn0sIHtcblx0dGl0bGU6ICdEaXJlaXRvcyBIdW1hbm9zJyxcblx0a2V5OiB1dWlkLnY0KCksXG5cdGNoaWxkcmVuOiBbXSxcblx0dHlwZTogJ2xpc3QnLFxuXHRpc1ByZW1pdW06IGZhbHNlLFxuXHR2YWx1ZTogJycsXG5cdHBhcmFtczoge31cbn0sIHtcblx0dGl0bGU6ICdEaXJlaXRvIEludGVybmFjaW9uYWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gUGVuYWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gUHJvY2Vzc3VhbCBDaXZpbCcsXG5cdGtleTogdXVpZC52NCgpLFxuXHRjaGlsZHJlbjogW10sXG5cdHR5cGU6ICdsaXN0Jyxcblx0aXNQcmVtaXVtOiBmYWxzZSxcblx0dmFsdWU6ICcnLFxuXHRwYXJhbXM6IHt9XG59LCB7XG5cdHRpdGxlOiAnRGlyZWl0byBQcm9jZXNzdWFsIFBlbmFsJyxcblx0a2V5OiB1dWlkLnY0KCksXG5cdGNoaWxkcmVuOiBbXSxcblx0dHlwZTogJ2xpc3QnLFxuXHRpc1ByZW1pdW06IGZhbHNlLFxuXHR2YWx1ZTogJycsXG5cdHBhcmFtczoge31cbn0sIHtcblx0dGl0bGU6ICdEaXJlaXRvIFByb2Nlc3N1YWwgZG8gVHJhYmFsaG8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gZG8gVHJhYmFsaG8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gVHJpYnV0w6FyaW8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0VzdGF0dXRvIGRhIENyaWFuw6dhIGUgZG8gQWRvbGVzY2VudGUnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ8OJdGljYScsXG5cdGtleTogdXVpZC52NCgpLFxuXHRjaGlsZHJlbjogW10sXG5cdHR5cGU6ICdsaXN0Jyxcblx0aXNQcmVtaXVtOiBmYWxzZSxcblx0dmFsdWU6ICcnLFxuXHRwYXJhbXM6IHt9XG59LCB7XG5cdHRpdGxlOiAnRmlsb3NvZmlhIGRvIERpcmVpdG8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufV07XG5cbmNvbnN0IE9BQnNlY29uZFBoYXNlVGVtcGxhdGUgPSBbe1xuXHR0aXRsZTogJ0RpcmVpdG8gQWRtaW5pc3RyYXRpdm8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gQ2l2aWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gQ29uc3RpdHVjaW9uYWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gRW1wcmVzYXJpYWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gUGVuYWwnLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gZG8gVHJhYmFsaG8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufSwge1xuXHR0aXRsZTogJ0RpcmVpdG8gVHJpYnV0w6FyaW8nLFxuXHRrZXk6IHV1aWQudjQoKSxcblx0Y2hpbGRyZW46IFtdLFxuXHR0eXBlOiAnbGlzdCcsXG5cdGlzUHJlbWl1bTogZmFsc2UsXG5cdHZhbHVlOiAnJyxcblx0cGFyYW1zOiB7fVxufV07XG5cbmV4cG9ydCBjb25zdCB0ZW1wbGF0ZXMgPSB7XG5cdE9BQmZpcnN0UGhhc2VUZW1wbGF0ZSxcblx0T0FCc2Vjb25kUGhhc2VUZW1wbGF0ZSxcblx0ZW1wdHlUZW1wbGF0ZTogW11cbn07XG5cbmV4cG9ydCBjb25zdCB0eXBlcyA9IFtcblx0eyBuYW1lOiAnUERGJywgdmFsdWU6ICdwZGYnLCB2YWxpZGF0aW9uOiBwZGZWYWxpZGF0aW9uIH0sXG5cdHsgbmFtZTogJ0xpbmsnLCB2YWx1ZTogJ3VybCcsIHZhbGlkYXRpb246IGxpbmtWYWxpZGF0aW9uIH0sXG5cdC8vIHsgbmFtZTogJ0Z1bsOnw6NvIEphdmFTY3JpcHQnLCB2YWx1ZTogJ2Z1bmN0aW9uJywgdmFsaWRhdGlvbjogZ2VuZXJpY1ZhbGlkYXRpb24gfSxcblx0Ly8geyBuYW1lOiAnVGVsYSBkbyBBcGxpY2F0aXZvIChTb21lbnRlIE1vYmlsZSknLCB2YWx1ZTogJ3dpZGdldCcsIHZhbGlkYXRpb246IGdlbmVyaWNWYWxpZGF0aW9uIH0sXG5cdHsgbmFtZTogJ0xpc3RhJywgdmFsdWU6ICdsaXN0JywgdmFsaWRhdGlvbjogbGlzdFZhbGlkYXRpb24gfSxcblx0Ly8geyBuYW1lOiAnV2VidmlldycsIHZhbHVlOiAnd2VidmlldycsIHZhbGlkYXRpb246IHdlYlZpZXdWYWxpZGF0aW9uIH0sXG5cdHsgbmFtZTogJ1RleHRvJywgdmFsdWU6ICd0ZXh0JywgdmFsaWRhdGlvbjogdGV4dFZhbGlkYXRpb24gfSxcblx0eyBuYW1lOiAnU3ViTGlzdGEnLCB2YWx1ZTogJ3N1Ykxpc3QnLCB2YWxpZGF0aW9uOiBsaXN0VmFsaWRhdGlvbiB9LFxuXHR7IG5hbWU6ICdJbWFnZW0nLCB2YWx1ZTogJ2ltYWdlJywgdmFsaWRhdGlvbjogaW1hZ2VWYWxpZGF0aW9uIH0sXG5cdHsgbmFtZTogJ1bDrWRlbycsIHZhbHVlOiAndmlkZW8nLCB2YWxpZGF0aW9uOiB2aWRlb1ZhbGlkYXRpb24gfSxcblx0eyBuYW1lOiAnU2VwYXJhZG9yJywgdmFsdWU6ICdzZXBhcmF0b3InLCB2YWxpZGF0aW9uOiAoKSA9PiB0cnVlIH0sXG5cdHsgbmFtZTogJ0l0ZW0gZGUgTGlzdGEnLCB2YWx1ZTogJ2xpc3RJdGVtJywgdmFsaWRhdGlvbjogbGlzdEl0ZW1WYWxpZGF0aW9uIH1cbl07XG5cbmZ1bmN0aW9uIGdlbmVyaWNWYWxpZGF0aW9uKHJvdykge1xuXHRpZiAodHlwZW9mIHJvdy50eXBlICE9PSAnc3RyaW5nJyB8fCByb3cudHlwZS5sZW5ndGggPT09IDApIHtcblx0XHRyZXR1cm4gJ3R5cGUnO1xuXHR9XG5cblx0aWYgKHR5cGVvZiByb3cudGl0bGUgIT09ICdzdHJpbmcnIHx8IHJvdy50aXRsZS5sZW5ndGggPT09IDApIHtcblx0XHRyZXR1cm4gJ3RpdGxlJztcblx0fVxuXG5cdGlmICh0eXBlb2Ygcm93LnZhbHVlICE9PSAnc3RyaW5nJyB8fCByb3cudmFsdWUubGVuZ3RoID09PSAwKSB7XG5cdFx0cmV0dXJuICd2YWx1ZSc7XG5cdH1cblx0XG5cdGlmICh0eXBlb2Ygcm93LmlzUHJlbWl1bSAhPT0gJ2Jvb2xlYW4nKSB7XG5cdFx0cmV0dXJuICdpc1ByZW1pdW0nO1xuXHR9XG5cblx0cmV0dXJuIHRydWU7XG59XG5cbmZ1bmN0aW9uIGxpc3RWYWxpZGF0aW9uKHJvdykge1xuXHRpZiAodHlwZW9mIHJvdy50eXBlICE9PSAnc3RyaW5nJyB8fCByb3cudHlwZS5sZW5ndGggPT09IDApIHtcblx0XHRyZXR1cm4gJ3R5cGUnO1xuXHR9XG5cblx0aWYgKHR5cGVvZiByb3cudGl0bGUgIT09ICdzdHJpbmcnIHx8IHJvdy50aXRsZS5sZW5ndGggPT09IDApIHtcblx0XHRyZXR1cm4gJ3RpdGxlJztcblx0fVxuXHRcblx0aWYgKHR5cGVvZiByb3cuaXNQcmVtaXVtICE9PSAnYm9vbGVhbicpIHtcblx0XHRyZXR1cm4gJ2lzUHJlbWl1bSc7XG5cdH1cblxuXHRyZXR1cm4gdHJ1ZTtcbn1cblxuZnVuY3Rpb24gdGV4dFZhbGlkYXRpb24ocm93KSB7XG5cdGlmICgodHlwZW9mIHJvdy52YWx1ZSAhPT0gJ3N0cmluZycgfHwgcm93LnZhbHVlLmxlbmd0aCA9PT0gMCkgJiYgKHR5cGVvZiByb3cudGl0bGUgIT09ICdzdHJpbmcnIHx8IHJvdy50aXRsZS5sZW5ndGggPT09IDApKSB7XG5cdFx0cmV0dXJuICd2YWx1ZSc7XG5cdH1cblxuXHRyZXR1cm4gdHJ1ZTtcbn1cblxuXG5mdW5jdGlvbiBsaXN0SXRlbVZhbGlkYXRpb24ocm93KSB7XG5cdGlmICh0eXBlb2Ygcm93LnZhbHVlICE9PSAnc3RyaW5nJyB8fCByb3cudmFsdWUubGVuZ3RoID09PSAwKSB7XG5cdFx0cmV0dXJuICd2YWx1ZSc7XG5cdH1cblxuXHRyZXR1cm4gdHJ1ZTtcbn1cblxuZnVuY3Rpb24gcGRmVmFsaWRhdGlvbihyb3cpIHtcblx0Y29uc3QgZ2VuZXJpYyA9IGdlbmVyaWNWYWxpZGF0aW9uKHJvdyk7XG5cblx0aWYgKGdlbmVyaWMgIT09IHRydWUpIHtcblx0XHRyZXR1cm4gZ2VuZXJpYztcblx0fVxuXG5cdGlmICghaXNVcmwocm93LnZhbHVlKSB8fCAhcm93LnZhbHVlLnRvTG93ZXJDYXNlKCkuaW5jbHVkZXMoJy5wZGYnKSkge1xuXHRcdHJldHVybiAndmFsdWUnO1xuXHR9XG5cblx0cmV0dXJuIHRydWU7XG59XG5cbmZ1bmN0aW9uIGltYWdlVmFsaWRhdGlvbihyb3cpIHtcblx0Y29uc3QgZ2VuZXJpYyA9IGdlbmVyaWNWYWxpZGF0aW9uKHJvdyk7XG5cblx0aWYgKGdlbmVyaWMgIT09IHRydWUpIHtcblx0XHRyZXR1cm4gZ2VuZXJpYztcblx0fVxuXG5cdGNvbnN0IHZhbHVlID0gcm93LnZhbHVlO1xuXHRjb25zdCB0aHVtYm5haWwgPSByb3cudGh1bWJuYWlsO1xuXG5cdGNvbnN0IGlzSW1hZ2UgPSBbJy5qcGcnLCAnLmdpZicsICcucG5nJywgJy5qcGVnJ10uc29tZSgoZm9ybWF0KSA9PiB2YWx1ZS50b0xvd2VyQ2FzZSgpLmluY2x1ZGVzKGZvcm1hdCkpO1xuXHRjb25zdCB0aHVtYm5haWxJc0ltYWdlID0gWycuanBnJywgJy5naWYnLCAnLnBuZycsICcuanBlZyddLnNvbWUoKGZvcm1hdCkgPT4gdGh1bWJuYWlsLnRvTG93ZXJDYXNlKCkuaW5jbHVkZXMoZm9ybWF0KSk7XG5cblx0aWYgKCFpc1VybCh2YWx1ZSkgfHwgIWlzSW1hZ2UpIHtcblx0XHRyZXR1cm4gJ3ZhbHVlJztcblx0fVxuXG5cdGlmICghaXNVcmwodGh1bWJuYWlsKSB8fCAhdGh1bWJuYWlsSXNJbWFnZSkge1xuXHRcdHJldHVybiAndGh1bWJuYWlsJztcblx0fVxuXG5cdHJldHVybiB0cnVlO1xufVxuXG5mdW5jdGlvbiB3ZWJWaWV3VmFsaWRhdGlvbihyb3cpIHtcblx0Y29uc3QgZ2VuZXJpYyA9IGdlbmVyaWNWYWxpZGF0aW9uKHJvdyk7XG5cblx0aWYgKGdlbmVyaWMgIT09IHRydWUpIHtcblx0XHRyZXR1cm4gZ2VuZXJpYztcblx0fVxuXG5cdGlmICghaXNVcmwocm93LnZhbHVlKSB8fCAhcm93LnZhbHVlLnRvTG93ZXJDYXNlKCkuaW5jbHVkZXMoJy5odG1sJykpIHtcblx0XHRyZXR1cm4gJ3ZhbHVlJztcblx0fVxuXG5cdHJldHVybiB0cnVlO1xufVxuXG5cbmZ1bmN0aW9uIGxpbmtWYWxpZGF0aW9uKHJvdykge1xuXHRjb25zdCBnZW5lcmljID0gZ2VuZXJpY1ZhbGlkYXRpb24ocm93KTtcblxuXHRpZiAoZ2VuZXJpYyAhPT0gdHJ1ZSkge1xuXHRcdHJldHVybiBnZW5lcmljO1xuXHR9XG5cblx0aWYgKCFpc1VybChyb3cudmFsdWUpKSB7XG5cdFx0cmV0dXJuICd2YWx1ZSc7XG5cdH1cblxuXHRpZiAodHlwZW9mIHJvdy5pc0V4dGVybmFsICE9PSAnYm9vbGVhbicgJiYgdHlwZW9mIHJvdy5pc0V4dGVybmFsICE9PSAndW5kZWZpbmVkJykge1xuXHRcdHJldHVybiAnaXNFeHRlcm5hbCc7XG5cdH1cblxuXHRyZXR1cm4gdHJ1ZTtcbn1cblxuZnVuY3Rpb24gdmlkZW9WYWxpZGF0aW9uKHJvdykge1xuXHRjb25zdCBnZW5lcmljID0gZ2VuZXJpY1ZhbGlkYXRpb24ocm93KTtcblxuXHRpZiAoZ2VuZXJpYyAhPT0gdHJ1ZSkge1xuXHRcdHJldHVybiBnZW5lcmljO1xuXHR9XG5cblx0aWYgKCFpc1VybChyb3cudmFsdWUpKSB7XG5cdFx0cmV0dXJuICd2YWx1ZSc7XG5cdH1cblx0XG5cdGlmIChcblx0XHR0eXBlb2Ygcm93LnRodW1ibmFpbCAhPT0gJ3VuZGVmaW5lZCcgJiZcblx0XHR0eXBlb2Ygcm93LnRodW1ibmFpbCAhPT0gJ3N0cmluZycgJiZcblx0XHQhaXNVcmwocm93LnRodW1ibmFpbClcblx0KSB7XG5cdFx0cmV0dXJuICd0aHVtYm5haWwnO1xuXHR9XG5cblx0cmV0dXJuIHRydWU7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/lib/genericMaterialDefaults.js
// module id = 297
// module chunks = 0